import React from 'react'
import { css } from '@emotion/core'
import { number, shape, string } from 'prop-types'
import { useOverlay } from '@fs/zion-ui'
import HeroCircle from '../HeroCircle'
import { defaultFills } from '../../pages/KidsHome/BackgroundFills'
import LeaderboardOverlay from '../LeaderboardOverlay'
import LandingPageBackground from '../LandingPageBackground'
import { BackgroundFillsType } from '../../sharedPropTypes/activityProps'
import StreaksOverlay from '../Streaks/StreaksOverlay'
import { useGetStreaks } from '../../hooks'

const topBannerCss = css`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  overflow: hidden;
`
export default function TopBanner({ points, fillColors = defaultFills, ...rest }) {
  const overlay = useOverlay()
  const streaksOverlay = useOverlay()
  const { data: getStreaksState } = useGetStreaks(true)

  // Derive streak values if available
  const endOfStreak = getStreaksState?.endOfWeek
  const totalActivities = getStreaksState?.totalActivities ?? 0
  const streakCount = getStreaksState?.streakCount ?? 0
  const isStreakCurrent = getStreaksState?.isCurrent ?? false

  return (
    <div css={topBannerCss} style={{ height: rest?.height }}>
      <LandingPageBackground height={rest?.height} fillColors={fillColors} />

      <div style={{ position: 'relative', height: '232px' }}>
        <HeroCircle {...rest} />
      </div>
      <LeaderboardOverlay overlay={overlay} />
      <StreaksOverlay
        streakCount={streakCount}
        endOfStreak={endOfStreak}
        overlay={streaksOverlay}
        totalActivities={totalActivities}
        isCurrent={isStreakCurrent}
      />
    </div>
  )
}

TopBanner.propTypes = {
  points: number,
  height: string,
  fillColors: BackgroundFillsType,
  rest: shape({
    bgref: string.isRequired,
  }),
}
